import angel from './images/angel.png';
import angry from './images/angry.png';
import blink from './images/blink.gif';
import cool from './images/cool.png';
import cry from './images/cry.png';
import devil from './images/devil.png';
import glad from './images/glad.png';
import happy from './images/happy.png';
import laugh from './images/laugh.gif';
import magic from './images/magic.png';
import ninja from './images/ninja.png';
import pinch from './images/pinch.png';
import pirate from './images/pirate.png';
import sad from './images/sad.png';
import shy from './images/shy.png';
import smile from './images/smile.png';
import surprised from './images/surprised.png';
import tongue from './images/tongue.png';
import unsure from './images/unsure.gif';
import waw from './images/waw.png';
import whistle from './images/whistle.png';
import wink from './images/wink.png';
import zorro from './images/zorro.png';

export default {
  ':ange:': angel,
  ':colere:': angry,
  o_O: blink,
  ':soleil:': cool,
  ":'(": cry,
  ':diable:': devil,
  '^^': glad,
  ':D': happy,
  ':lol:': laugh,
  ':magicien:': magic,
  ':ninja:': ninja,
  '>_<': pinch,
  ':pirate:': pirate,
  ':(': sad,
  ':honte:': shy,
  ':)': smile,
  ':o': surprised,
  ':p': tongue,
  ':euh:': unsure,
  ':waw:': waw,
  ':-°': whistle,
  ';)': wink,
  ':zorro:': zorro,
};
